import makeStyles from '@mui/styles/makeStyles';
import cx from 'classnames';

import { primary } from '@/theme/colors';

const useStyles = makeStyles(() => ({
  root: {
    margin: '20px 0',
    color: primary,
    fontWeight: 'bold',
    cursor: 'pointer',
    display: 'inline-block',
    '&:hover': {
      filter: 'brightness(1.3)',
    },
  },
}));

export default function AddButton({ onClick, className, label, ...rest }: any) {
  const s = useStyles();

  return (
    <div
      {...rest}
      className={cx(s.root, className)}
      onClick={onClick}
      id={`expertRequestsAdd${label}Button`}
    >
      Add {label}
    </div>
  );
}
